import { useTranslation } from 'next-i18next';

import {
  BannerContainer,
  BannerWrapper,
  DescriptionText,
  IconWrapper,
  RadarIcon,
  TextContent,
  TitleText,
} from './style';

type Props = {
  title?: string;
  description?: string;
};

const CourseNotFoundSuggestionMessage = ({ title, description }: Props) => {
  const { t } = useTranslation('common');

  return (
    <BannerWrapper>
      <BannerContainer>
        <TextContent>
          <TitleText>{title ?? t('all_course.course_not_found.title')}</TitleText>
          <DescriptionText>{description ?? t('all_course.course_not_found.desc')}</DescriptionText>
        </TextContent>
        <IconWrapper>
          <RadarIcon icon="fa-light fa-radar" />
        </IconWrapper>
      </BannerContainer>
    </BannerWrapper>
  );
};

export default CourseNotFoundSuggestionMessage;
